<template>
  <SfModal v-if="showModal" size="xs" @close="closeModal">
    <template #title>
      {{ modalTitle }}
    </template>
    <template #body>
      <div class="sf-below-2">
        {{ modalText1 }}
      </div>
      <div class="sf-below-4">
        {{ modalText2 }}
      </div>
      <div class="sf-below-1 sf-level sf-level-center">
        <a class="sf-btn sf-btn-success" @click="confirmModal">
          {{ modalConfirmButton }}
        </a>
        <a class="sf-btn" @click="closeModal">
          {{ modalCancelButton }}
        </a>
      </div>
    </template>
  </SfModal>
</template>

<script type="text/javascript">
import { SfModal } from '@app/shared/vue/components/sf-modal'
import SFetch from '@app/utils/sfetch'

export default {
  name: 'ContactProductModal',
  components: { SfModal },
  data() {
    return {
      showModal: true,
      type: '',
    }
  },
  computed: {
    modalTitle() {
      return I18n.t('trials.landing.contact_expert_modal.title')
    },
    modalText1() {
      return I18n.t('trials.landing.contact_expert_modal.text_1')
    },
    modalText2() {
      return I18n.t('trials.landing.contact_expert_modal.text_2')
    },
    modalConfirmButton() {
      return I18n.t('trials.landing.contact_expert_modal.confirm_button')
    },
    modalCancelButton() {
      return I18n.t('trials.landing.contact_expert_modal.cancel_button')
    },
  },
  methods: {
    openModal({ type }) {
      this.type = type
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    confirmModal() {
      const firmId = Silverfin.currentFirmId
      SFetch.json(Silverfin.Routes.contact_expert_trials_path(firmId), {
        method: 'POST',
        body: { type: this.type },
      }).then(() => {
        this.showModal = false
      })
    },
  },
}
</script>
